module.exports = __webpack_public_path__ + "img/screenshot (1).643faec4.jpg";